/**
 * this renders on https://local.hungryroot.com/recipes/yuzu-miso-chicken-ramen-noodles-463826/?utm_source=ios_app&utm_medium=share_sheet
 */

import { renderApp } from './utils/utils';
import Rdp_v2 from './generic/pairing_cards_v2/Rdp_v2';
import CtaHeader from './generic/CtaHeader';
import { Provider } from 'react-redux';
import { reducer } from '../../../components/SaveRecipes/favorites.reducer';
import { combineReducers, createStore } from 'redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { queryClient, queryClientOptions } from '@hungryroot/rest';
import { useRdpPdpDeepLinkRedirect } from '@hungryroot/rdp';

const preCheckout = !!parseInt(window.preCheckout);
const surveyStartedFoods = window.surveyStarted;

/**
 * This component is still in use as of 2025-07-01 by the /recipes/:id/ route.
 */
const RecipePageContent = () => {
  const pairingId = window.pairingId;
  const { loading: redirectLoading } = useRdpPdpDeepLinkRedirect(
    'recipe',
    pairingId
  );

  return (
    <Provider store={store}>
      <Rdp_v2
        loading={redirectLoading}
        onPairingLoad={(pairing) =>
          store.dispatch({
            type: 'RECIPE_FAVORITE_CHANGE',
            isFavorite: pairing.is_favorited,
            recipeId: pairing.id,
          })
        }
      />
    </Provider>
  );
};

const store = createStore(
  combineReducers({
    favorites: reducer,
  })
);

renderApp(
  <QueryClientProvider client={queryClient}>
    <CtaHeader
      isFoodsPage={true}
      isOnPDP={true}
      preCheckout={preCheckout}
      surveyStartedFoods={surveyStartedFoods}
    />
  </QueryClientProvider>,
  'cta-header'
);
renderApp(
  <QueryClientProvider client={new QueryClient(queryClientOptions)}>
    <RecipePageContent />
  </QueryClientProvider>,
  'react-recipe-modal'
);
